import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { checkUserProductAccess_ } from 'hooks/datahook/platformSettings';
import { useAuth } from 'hooks/useAuth';
import { Spinner, Center } from '@chakra-ui/react';
import { paths } from 'routes/path';

const ProductAccessGuard = ({ children, productCode }) => {
    const { user } = useAuth();
    const [hasAccess, setHasAccess] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const checkAccess = async () => {
            if (!user?.id || !productCode) {
                setHasAccess(false);
                setLoading(false);
                return;
            }

            try {
                const result = await checkUserProductAccess_({
                    userId: user.id,
                    productCode: productCode,
                });
                // API 返回 { success: true, data: { isAllowed: true/false, ... } }
                setHasAccess(result?.data?.isAllowed === true);
            } catch (error) {
                console.error('Failed to check product access:', error);
                setHasAccess(false);
            } finally {
                setLoading(false);
            }
        };

        checkAccess();
    }, [user?.id, productCode]);

    if (loading) {
        return (
            <Center h="100vh">
                <Spinner size="xl" />
            </Center>
        );
    }

    if (!hasAccess) {
        return <Navigate to={paths.home} replace />;
    }

    return <>{children}</>;
};

export default ProductAccessGuard;
